import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.'

@vsingleton()
export class AdminPersonRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'api.'

  getPersons() {
    return this.ziggyRoute('persons')
  }
}
